import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=cdef22f4&scoped=true"
import script from "./datetime.vue?vue&type=script&lang=ts"
export * from "./datetime.vue?vue&type=script&lang=ts"
import style0 from "./datetime.vue?vue&type=style&index=0&id=cdef22f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdef22f4",
  null
  
)

export default component.exports